var extStyle = document.createElement("link");
extStyle.rel = "stylesheet";
extStyle.href = "/css/scopedEditorStyles.css";
document.head.appendChild(extStyle);